export const RANK_REPRESENTING_WORST_MATCH_FOR_UI = 999;
export const RANK_REPRESENTING_WORST_MATCH_FROM_SERVICE = 0;
